export enum ResetPasswordStep {
  Expired = 1,
  Reset = 2,
  Success = 3,
  ConnectionError = 4,
}
